"use client";
import { jsxs as e, jsx as o } from "react/jsx-runtime";
import { memo as r } from "react";
import m from "../components/Icon/SvgIcon.js";
const h = (t) => /* @__PURE__ */ e(
  m,
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none",
    ...t,
    children: [
      /* @__PURE__ */ o("path", { fill: "#fff", d: "M7 11h10v2H7z" }),
      /* @__PURE__ */ o(
        "path",
        {
          fill: "currentColor",
          d: "M19 3H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2m-2 10H7v-2h10z"
        }
      )
    ]
  }
), f = r(h);
export {
  f as CheckboxIndeterminate,
  f as default
};
